export const MOON_GRAY = '#4d6d7c'
export const ORANGE = '#bd5709'
export const NAVY = '#033048'
export const GREEN = '#0bb66f'

const statusColors = {
  ok: {
    fill: '#17CC81',
    stroke: '#15B774',
  },
  warn: {
    fill: '#FFEA26',
    stroke: '#E8D523',
  },
  alert: {
    fill: '#C81349',
    stroke: '#AC103F',
  },
  unknown: {
    fill: '#033048',
    stroke: '#03202F',
  },
  'not-available': {
    fill: '#E5EAEC',
    stroke: '#C5D0D4',
  },
}

export const getStatusColor = (type) =>
  statusColors[type] || statusColors['not-available']
